// import myComponentScript from "./myComponentScript.js";
import js from "./faq";
